import React from 'react';
import PropTypes from 'prop-types';

function TwitterIcon({ color, width, height }) {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* eslint-disable-next-line max-len */}
      <path d="M9.47665 28.8329C12.126 28.9216 14.7662 28.4782 17.2413 27.5291C19.7163 26.58 21.976 25.1444 23.8868 23.3071C25.7976 21.4698 27.3207 19.2681 28.3661 16.8321C29.4115 14.3962 29.958 11.7754 29.9733 9.1246C31.1874 7.62213 32.089 5.89213 32.625 4.03627C32.665 3.88964 32.6618 3.73457 32.6157 3.58974C32.5696 3.4449 32.4826 3.31648 32.3653 3.21992C32.2479 3.12337 32.1051 3.0628 31.9541 3.04552C31.8031 3.02824 31.6503 3.05498 31.5141 3.12252C30.879 3.42827 30.1639 3.52704 29.4696 3.40489C28.7753 3.28275 28.1368 2.94586 27.6441 2.44168C27.0152 1.75293 26.2544 1.19743 25.4068 0.808091C24.5592 0.418757 23.6421 0.203511 22.7098 0.175107C21.7775 0.146704 20.849 0.305722 19.9793 0.642738C19.1096 0.979754 18.3164 1.48791 17.6466 2.1371C16.7297 3.02516 16.058 4.13533 15.697 5.35973C15.3359 6.58412 15.2978 7.8811 15.5862 9.1246C9.58415 9.48293 5.46332 6.63418 2.16665 2.72835C2.06761 2.61619 1.93806 2.5353 1.79381 2.49556C1.64956 2.45581 1.49686 2.45893 1.35435 2.50453C1.21185 2.55013 1.0857 2.63625 0.991327 2.75235C0.89695 2.86846 0.838425 3.00953 0.822899 3.15835C0.194865 6.64211 0.647906 10.2346 2.12117 13.4534C3.59444 16.6722 6.01738 19.363 9.06456 21.1646C7.02141 23.5078 4.15219 24.9713 1.05582 25.2496C0.889929 25.2771 0.736795 25.3558 0.617845 25.4746C0.498896 25.5935 0.420084 25.7466 0.39244 25.9124C0.364796 26.0783 0.389704 26.2487 0.463676 26.3997C0.537649 26.5507 0.656985 26.6748 0.804982 26.7546C3.49879 28.1008 6.46527 28.8118 9.47665 28.8329Z" fill={color} />
    </svg>
  );
}

TwitterIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

TwitterIcon.defaultProps = {
  color: '#7ED321',
  width: '33',
  height: '29',
};

export default React.memo(TwitterIcon);
